import { ArableService } from '../../shared/services/arable.service';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { BYPASS_CHAIN_PARTY_INTERCEPTOR } from '../interceptors/chain-party-interceptor.context';
import { AssociatedChainPartner } from '../models/models';

@Injectable({ providedIn: 'root' })
export class AssociatedChainPartnerService extends ArableService {
  private readonly http = inject(HttpClient);

  private readonly path = new URL('associated-chain-partner', this.baseUrl).toString();

  retrieveAssociatedChainPartner() {
    const context = new HttpContext().set(BYPASS_CHAIN_PARTY_INTERCEPTOR, true);

    return this.http.get<AssociatedChainPartner>(this.path, { context });
  }
}
